var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"markdown",domProps:{"innerHTML":_vm._s(_vm.convertedHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }